import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { TeamShipHealth, SharpshooterUserSessionAdditionalInfo } from './sharpshooter-types';
import { TeamScoreboard } from './team-scoreboard';

import './styles/end-screen.css';
import { useEventContext, useQuizContext, useQuizSessionContext } from 'contexts';
import { NavUtils, NavPages } from 'utils';

interface Props {
    isSinglePlayer: boolean;
    correctAnswers: number;
    incorrectAnswers: number;
    teamShipStatus: TeamShipHealth[];
}

export const SharpshooterEndScreen = (props: Props) => {
    const { quiz } = useQuizContext();
    const sessionContext = useQuizSessionContext();
    const event = useEventContext();
    const navigate = useNavigate();

    const getWinningTeam = () => {
        const winner = props.teamShipStatus.find((t) => t.ships - t.destroyed > 0);
        return winner?.name;
    };

    const onQuizListClick = () => {
        navigate(NavUtils.generateNavPath(NavPages.QuizSelector, undefined, event?.alias));
    };

    const getShipStatuses = (): TeamShipHealth[] => {
        const lTeamShipStatus = [...props.teamShipStatus];
        if (sessionContext) {
            const shipStatuses = (sessionContext?.userSession?.additionalInfo as SharpshooterUserSessionAdditionalInfo)?.shipStatus;
            if (shipStatuses) {
                shipStatuses.forEach((ss) => {
                    const cTeam = lTeamShipStatus.find((t) => t.name === ss.teamName)!;
                    cTeam.destroyed = ss.sunkShips;
                });
            }
        }

        return lTeamShipStatus;
    };

    const correctAnswers = sessionContext?.userSession?.correctAnswers ?? props.correctAnswers;
    const incorrectAnswers = sessionContext?.userSession?.answersAttempted
        ? sessionContext?.userSession?.answersAttempted - correctAnswers
        : props.incorrectAnswers;

    return (
        <Box className="end-screen-wrapper">
            <Paper variant="elevation" elevation={3}>
                <Stack className="end-screen-stack" direction="column" spacing={2}>
                    <h2 className="quiz-title">{quiz.name}</h2>
                    <Stack direction="row" spacing={2} className="question-score" padding="0 30px">
                        <Typography variant="body1">Total correctly answered questions:</Typography>
                        <Typography variant="body1">{correctAnswers}</Typography>
                    </Stack>
                    <Stack direction="row" spacing={2} justifyContent="space-between" padding="0 30px">
                        <Typography variant="body1">Total incorrectly answered questions:</Typography>
                        <Typography variant="body1">{incorrectAnswers}</Typography>
                    </Stack>
                    {!props.isSinglePlayer && (
                        <Stack direction="row" spacing={2} justifyContent="space-between" padding="0 30px">
                            <Typography variant="h3">WINNER:</Typography>
                            <Typography variant="h3">{getWinningTeam()}</Typography>
                        </Stack>
                    )}
                    <TeamScoreboard teamShipStatus={getShipStatuses()} />
                    <Button onClick={onQuizListClick}> Back to Quiz List</Button>
                </Stack>
            </Paper>
        </Box>
    );
};
